module.exports = {"330783001":"吴宁街道","330783003":"南市街道","330783004":"白云街道","330783005":"江北街道","330783006":"城东街道","330783007":"六石街道","330783106":"巍山镇","330783107":"虎鹿镇","330783108":"歌山镇","330783109":"佐村镇","330783110":"东阳江镇","330783112":"湖溪镇","330783114":"马宅镇","330783116":"千祥镇","330783118":"南马镇","330783122":"画水镇","330783123":"横店镇","330783201":"三单乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/330783.json
// module id = 1107
// module chunks = 0